module.exports = {
  message: {
    hello_world: '世界 你好'
  },
  down: {
      grid_bot: '网格量化工具',
      overcome_emotional: '克服投资情绪',
      fortune_market: '轻松穿越牛熊',
      contact_email: '联系客服邮箱',
      copy_success: '复制成功',
      copy_failed: '复制失败',
      press_copy: '请长按邀请码进行复制',
		overseas: '需要海外',
		register_guide: '注册美区ID指引',
		recommend:'推荐',
		enterprise:'企业签名版',
  },
  sign: {
      register_id: '注册账号',
      mobile_regist: '手机注册',
      email_regist: '邮箱注册',
      input_phone: '请输入手机号',
      input_email: '请输入邮箱地址',
      set_password: '请设置密码',
      password_rule: '8-16位数字、字母组合',
      password_warn: '要同时含有数字和字母，长度在8-16位之间',
      invite_code: '推荐人邀请码',
      agree: '我已阅读并同意',
      user_agr: '《用户协议》',
      privacy_agr: '《隐私协议》',
      and: '和',
      regist: '注册',
      agree_warn: '请先阅读并同意协议',
      already_regist: '已注册？点击下载',
      phone_warn: '手机号码输入有误，请重新填写',
      email_warn: '邮箱格式有误，请重新填写',
      input_code: '输入验证码',
      code_sended: '验证码已发送至：',
      re_get: '后重新获取',
      regist_success: '恭喜您注册成功！',
      down_app: '下载APP',
      user_exists: '该用户已存在',
      resend: '重新获取',
      wrong_code: '验证码有误',
      choose_area: '选择国家或地区',
      search: '搜索',
  },
  common: {
    jgz: 'JGZ',
    jgz_down: 'JGZ下载',
    invite_regist: '邀请注册',
    open_in_browser: '请在浏览器中打开',
    jgz_team: 'JGZ团队',
    refresh: '点击刷新',
    
  },
  invite: {
    scan_down: '扫码下载JGZ APP',
    invite_code: '邀请码',
    invite: '立即邀请',
    not_apple: '本活动与苹果公司无关',
    invite_friend: '邀请好友',
    get_bot: '一起量化'
  },
  activity: {
    jgz_activity: 'JGZ活动',
    failed: '欧呦！获取失败。',
    course: '教程',
  },
  alarm: {
    how: '如何添加预警？',
    way: '登录状态下，打开任意交易对K线页面，点击预警按钮，即可添加价格预警。'
  }
}
